export enum SocialMediaType {
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
  INSTAGRAM = 'instagram',
  GITHUB = 'github',
  BUYCOFFEE = 'buycoffee',
}
